import { ref } from 'vue';
import cookies from 'vue-cookies';
import UserService from './service';

const props = ref({
  user: ref({
    email: '',
    password: '',
    name: '',
    profileUrl: '',
    phoneNumber: '',
  }),
  passwordReset: ref({
    password: '',
    passwordConfirm: '',
    key: '',
  }),
  createUser: ref({
    email: '',
    password: '',
    name: '',
    termSign: {
      ip: '',
      geolocation: '',
      city: '',
      uf: '',
      country: '',
      deviceId: '',
    },
  }),
});

function setCookie(sessionId, validade) {
  const urlApplication = window.location.hostname;
  const pathApplication = '/';
  const diasValidadeCookie = validade || '6d';
  cookies.set('SessionId', sessionId, diasValidadeCookie, pathApplication, urlApplication);
}

function setCookieTarget(validade) {
  const urlApplication = window.location.hostname;
  const pathApplication = '/';
  const diasValidadeCookie = validade || '6d';
  cookies.set('Target', '1', diasValidadeCookie, pathApplication, urlApplication);
}

function setUser(value) {
  props.value.user = value;
}

function setKeyReset(value) {
  props.value.passwordReset.key = value;
}

async function logOut() {
  await UserService.removeSessionToken();
  setCookie(null, '0s');
  window.location.href = '/user/login';
}

function validUserLogged() {
  const sessionIdCookie = cookies.get('SessionId');

  if (sessionIdCookie !== '') {
    UserService.validSession()
      .then(() => {
        setCookie(sessionIdCookie);
        window.location.href = '/welcome';
      })
      .catch((err) => {
        console.log(err);
        setCookie(null, '0s');
      });
  }
}

export { props, validUserLogged, setCookie, setCookieTarget, setUser, setKeyReset, logOut, UserService };
